import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-print-tc',
  templateUrl: './print-tc.component.html',
  styleUrls: ['./print-tc.component.css']
})
export class PrintTCComponent implements OnInit {
  SearchModel = {
    StudentTCID: '0',  
    PrintType:'', 

}
IssueTCModel:any;
BranchDetails:any;

  constructor(private activatedRoute: ActivatedRoute,private financeService:FinanceService,private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 
    this.activatedRoute.queryParams.subscribe(params => {
     
      this.SearchModel.StudentTCID =  params['StudentTCID'];
      this.SearchModel.PrintType=params['PrintType']; 
      this.GetStudentTCPrint ()
  });
  }
 
  dayTowords (s) {
    
    if (s != 'undefined' && s != '' && s != null) {
      var th = ['', 'thousand', 'million', 'billion', 'trillion'];
      var dg = ['zero', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth'];
      var tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
      var tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        s = s.toString();
        s = s.replace(/[\, ]/g, '');
        if (s != parseFloat(s)) return 'not a number';
        var x: number = s.indexOf('.');
        if (x == -1) x = s.length;
        if (x > 15) return 'too big';
        var n = s.split('');
        var str = '';
        var sk = 0;
        for (var i = 0; i < x; i++) {
            if ((x - i) % 3 == 2) {
                if (n[i] == '1') {
                    str += tn[Number(n[i + 1])] + ' ';
                    i++;
                    sk = 1;
                }
                else if (n[i] != 0) {
                    str += tw[n[i] - 2] + ' ';
                    sk = 1;
                }
            }
            else if (n[i] != 0) {
                str += dg[n[i]] + ' ';
                if ((x - i) % 3 == 0) str += 'hundred ';
                sk = 1;
            }


            if ((x - i) % 3 == 1) {
                if (sk) str += th[(x - i - 1) / 3] + '';
                sk = 0;
            }
        }
        if (x != s.length) {
            var y: number = s.length;
            str += 'point ';
            for (var i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
        }
        return str.replace(/\s+/g, ' ');
    }
}
  GetStudentTCPrint  () {
    
 
     this.spinnerService.show();
     this.studentService.GetStudentTCPrint(JSON.stringify(this.SearchModel)).subscribe( (response)=> {
       this.spinnerService.hide();
            
              this.BranchDetails = response.BranchDetails;
                let IssueTCModel1 = response.StudentDetails;
              this.IssueTCModel=IssueTCModel1;
              //  this.IssueTCModel.DOB =IssueTCModel1.DOB == null ? "" : moment(IssueTCModel1.DOB).format("DD-MMM-YYYY");
              //  this.IssueTCModel.AttendanceLastDate =IssueTCModel1.AttendanceLastDate == null ? "" :  moment(IssueTCModel1.AttendanceLastDate).format("DD-MMM-YYYY");
              //  this.IssueTCModel.CertificateDate =IssueTCModel1.CertificateDate == null ? "" :  moment(IssueTCModel1.CertificateDate).format("DD-MMM-YYYY") ;
              //  this.IssueTCModel.IssueDate = IssueTCModel1.IssueDate == null ? "" :moment(IssueTCModel1.IssueDate).format("DD-MMM-YYYY") ;
             
               setTimeout( () =>{
                window.print();
            }, 200);
           
            
           
         })
     
 }

  ngOnInit() {
  }

}
